export default __webpack_public_path__ + "static/borrow-page-4235c44a8abca3b2d0ee19802b7ab46b.png";